import {Component, OnInit} from '@angular/core';
import {FilterData} from "../interface/filter-data";
import {Router} from "@angular/router";
import {FilterControls} from "../interface/filter-controls";
import {FabricFilters} from "../model/fabric-filters";
import {FinishFilters} from "../model/finish-filters";

@Component({
  selector: 'fb-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {

	public filterData: FilterData = {
		name: '',
		group: '',
		controls: {} as FilterControls
	};

	constructor(
		private _router: Router
	) {
	}

	ngOnInit(): void {
		this._resolveFilterType();
	}

	private _resolveFilterType(): void {
		const filterType: string = this._router.url
			.split('?')[0]
			.split('/')[2]
			.trim()
			.toLowerCase();

		switch (filterType) {
			case 'fabric':
				this.filterData = {
					name: 'Fabrics',
					group: 'fabric-product',
					controls: FabricFilters.get()
				};
				break;
			case 'finished':
				this.filterData = {
					name: 'Finished',
					group: 'finished-product',
					controls: FinishFilters.get()
				};
				break;
			default:
				this._router.navigate(['/filter']).then(r => {
					if (!r) console.error('error routing to default filter!');
				});
				break;
		}
	}
}
